import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Identifies the alert being finished, so the operator can see which alert
 * the confirmation applies to before closing it for good.
 */
export interface CompleteAlertConfirmData {
  header: string;
  productId: string;
}

/**
 * Confirmation dialog shown before an alert is finished in the control room.
 * Closes with `true` when the operator confirms, `false` on cancel and
 * `undefined` when dismissed (backdrop click or escape), so anything other
 * than an explicit confirmation leaves the alert open.
 */
@Component({
    selector: 'app-complete-alert-confirm-dialog',
    templateUrl: './complete-alert-confirm-dialog.component.html',
    styleUrls: ['./complete-alert-confirm-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule]
})
export class CompleteAlertConfirmDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<CompleteAlertConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: CompleteAlertConfirmData
  ) { }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
